import React from 'react';

import { Button } from '@/components/ui/button';

/**
 * ClearFiltersButton - Standard button for clearing table filters
 *
 * Use this component for all "Clear Filters" buttons to ensure
 * consistent sizing (xxs) and styling across the application.
 *
 * @example
 * {hasActiveFilters && <ClearFiltersButton onClick={clearAllFilters} />}
 */
export const ClearFiltersButton: React.FC<{
  onClick: () => void;
  label?: string;
}> = ({ onClick, label = 'Clear Filters' }) => (
  <Button
    variant="outline"
    size="sm"
    className="text-chariot-brand-primary rounded-full border-none"
    onClick={onClick}
  >
    {label}
  </Button>
);
